import Lottie from 'lottie-web';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

import Swiper from 'swiper/bundle';
import 'swiper/css';
import 'swiper/css/pagination';

export default class Main {
    constructor() {
        this._init();
    }

    _init() {
        setTimeout(() => {
            this._topLogoAnimation();
            this._topLogoAnimationSP();
            this._footerLogoAnimation();
        }, 1000);

        window.addEventListener('load', () => {
            this._setMvSwiper();
        });
    }

    _topLogoAnimation() {
        const targetElm = document.querySelector('.js-top-lottie');

        const lottie = Lottie.loadAnimation({
            container: targetElm,
            renderer: 'svg',
            loop: false,
            autoplay: true,
            path: targetElm.getAttribute('src'),
        });
        lottie.addEventListener('complete', () => {});
    }

    _topLogoAnimationSP() {
        const targetElm = document.querySelector('.js-top-lottie-sp');

        const lottie = Lottie.loadAnimation({
            container: targetElm,
            renderer: 'svg',
            loop: false,
            autoplay: true,
            path: targetElm.getAttribute('src'),
        });
        lottie.addEventListener('complete', () => {});
    }

    _footerLogoAnimation() {
        const targetElm = document.querySelector('.js-vol2-lottie');

        const lottie = Lottie.loadAnimation({
            container: targetElm,
            renderer: 'svg',
            loop: false,
            autoplay: false,
            path: targetElm.getAttribute('src'),
        });
        lottie.addEventListener('complete', () => {});

        ScrollTrigger.create({
            trigger: targetElm,
            start: 'top 85%',
            onEnter: () => {
                lottie.play();
            },
            once: true,
        });
    }

    _setMvSwiper() {
        const option = {
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
            loop: true,
            effect: 'flip',
            pagination: { el: '.js-mainvisual-slide-pagenation', clickable: true },
        };

        const swiper = new Swiper('.js-mainvisual-swiper', option);
    }
}
